import { MutableRefObject, useCallback, useEffect, useState } from 'react';
// import { throttle } from '../helpers/throttle';
import { debounce, throttle } from 'lodash';

export type GetDimensionsType = {
  width: number;
  height: number;
  hasScrollbar: boolean;
};

const getDimensions = (el: Element): GetDimensionsType => {
  const { clientWidth: width, clientHeight: height } = el;
  const hasScrollbar = el.scrollHeight > height;

  return {
    width,
    height,
    hasScrollbar
  };
};

export const useDimensions = (ref: MutableRefObject<HTMLElement | null>, debounceMs?: number) => {
  const [dimensions, setDimensions] = useState<GetDimensionsType>({
    width: 0,
    height: 0,
    hasScrollbar: false
  });

  const handleResize = throttle(() => {
    if (ref.current) {
      setDimensions(getDimensions(ref.current));
    }
  }, 75);

  const handleResizeWithDebounce = debounce(() => {
    if (ref.current) {
      setDimensions(getDimensions(ref.current));
    }
  }, debounceMs);

  const callBack = useCallback(() => {
    if (debounceMs) {
      handleResizeWithDebounce();
    } else {
      handleResize();
    }
    // TODO-FIX-TS-WARNINGS
    // eslint-disable-next-line
  }, [debounceMs]);

  const resizeObserver = new ResizeObserver(() => callBack());

  useEffect(() => {
    if (ref.current) {
      resizeObserver.observe(ref.current);
    } else {
      resizeObserver.disconnect();
    }

    return () => resizeObserver.disconnect();
    // TODO-FIX-TS-WARNINGS
    // eslint-disable-next-line
  }, [ref.current]);

  return dimensions;
};
